export class DateTimeHandler {
  static getPeriodString = (years: number, months: number) => {
    let result = "";

    if(years !== 0){
      result = `${years} `;
      if (years > 10 && years < 20){
        result += "лет"
      } else if (years % 10 === 1){
        result += "год"
      } else if (years % 10 > 1 && years % 10 < 5){
        result += "год"
      } else {
        result += "лет"
      }
      result += " "
    }

    if(months !== 0){
      result += `${months} `;
      if (months === 1){
        result += "месяц"
      } else if (months > 1 && months < 5){
        result += "месяца"
      } else {
        result += "месяцев"
      }
    }

    return result;
  }

  static getMonthName = (monthIndex: number) => {
    switch (monthIndex) {
      case 0 :
        return "Январь"
      case 1 :
        return "Февраль"
      case 2 :
        return "Март"
      case 3 :
        return "Апрель"
      case 4 :
        return "Май"
      case 5 :
        return "Июнь"
      case 6 :
        return "Июль"
      case 7 :
        return "Август"
      case 8 :
        return "Сентябрь"
      case 9 :
        return "Октябрь"
      case 10 :
        return "Ноябрь"
      case 11 :
        return "Декабрь"
    }

    return ""
  }

  static getWorksPeriod = (start: Date, finish: Date) => {
    let result = `${start.getFullYear()} `
    result += this.getMonthName(start.getMonth())

    result += " \u2013 "

    if (!finish){
      result += "по настоящее время "
    } else {
      result += `${finish.getFullYear()} `
      result += this.getMonthName(finish.getMonth());
    }

    let yearsDifference;
    let monthsDifference;

    if (!finish){
      const current = new Date();
      yearsDifference =  current.getFullYear() - start.getFullYear();
      monthsDifference = current.getMonth() - start.getMonth();
      if (monthsDifference <= 0){
        if (!(current.getFullYear() === start.getFullYear())){
          monthsDifference = 12 + monthsDifference
          yearsDifference --;
        }
      }
    } else {
      yearsDifference =  finish.getFullYear() - start.getFullYear();
      monthsDifference = finish.getMonth() - start.getMonth();
      if (monthsDifference <= 0){
        if (!(finish.getFullYear() === start.getFullYear())){
          monthsDifference = 12 + monthsDifference
          yearsDifference --;
        }
      }
    }

    result += ` (${this.getPeriodString(yearsDifference, monthsDifference)})`

    return result;
  }

  static findFullExperience = (experience: any) => {

    const currentYear = new Date().getFullYear()
    const currentMonthIndex = new Date().getMonth()

    let yearsTotalDifference = 0;
    let monthTotalDifference = 0;

    for (let i = 0; i < experience.length; i ++){

      if (experience[i].finish === null){
        yearsTotalDifference += currentYear - experience[i].start.getFullYear();
        const monthDifference = currentMonthIndex - experience[i].start.getMonth();
        if (monthDifference <= 0){
          if (!(currentYear === experience[i].start.getFullYear())){
            monthTotalDifference += 12 + monthDifference
            yearsTotalDifference --;
          }
        } else {
          monthTotalDifference += monthDifference
        }
      } else {
        yearsTotalDifference += experience[i].finish.getFullYear() - experience[i].start.getFullYear();
        const monthDifference = experience[i].finish.getMonth() - experience[i].start.getMonth();
        if (monthDifference <= 0){
          if (!(experience[i].finish.getFullYear() === experience[i].start.getFullYear())){
            monthTotalDifference += 12 + monthDifference
            yearsTotalDifference --;
          }
        } else {
          monthTotalDifference += monthDifference
        }
      }

    }

    yearsTotalDifference += Math.floor(monthTotalDifference / 12)
    monthTotalDifference = monthTotalDifference % 12

    return this.getPeriodString(yearsTotalDifference, monthTotalDifference);
  }

}

export const getMonthName = (monthIndex: string) => {
  switch (monthIndex) {
    case '01' : return 'января'
    case '02' : return 'февраля'
    case '03' : return 'марта'
    case '04' : return 'апреля'
    case '05' : return 'мая'
    case '06' : return 'июня'
    case '07' : return 'июля'
    case '08' : return 'августа'
    case '09' : return 'сентября'
    case '10' : return 'октября'
    case '11' : return 'ноября'
    case '12' : return 'декабря'
  }
}

export const getMessagesDate = (dateTime: string) => {
  const today = new Date();
  const todayDate = today.getDate();
  const todayMonth = today.getMonth() + 1;
  const todayYear = today.getFullYear();
//TODO: переписать с использованием класса Date
  const messageDateParts = dateTime.toString().split('T')[0].split('-');
  const messageDay = parseInt(messageDateParts[2]);
  const messageMonth = messageDateParts[1];
  const messageYear = parseInt(messageDateParts[0]);

  let dateForShow = '';
  if (todayDate === messageDay && todayMonth === parseInt(messageMonth) && todayYear === messageYear) {
      dateForShow = 'Сегодня';
  } else {
      dateForShow = `${messageDay} ${getMonthName(messageMonth)}`;
  }
  return dateForShow;
}

export const getOnlyTime = (dateTime: string) => {
  const date = new Date(dateTime)
  return `${date.getHours()}:${('0' + date.getMinutes()).slice(-2)}`;
}

export const getLastChatDate = (dateTime: string) => {
  const today = new Date();
  const messageDate = new Date(dateTime);
  const messageDateParts = dateTime.toString().split('T')[0].split('-');
  const todayDate = today.getDate();
  const todayMonth = today.getMonth() + 1;
  const todayYear = today.getFullYear();

  const difference = today.getTime() - messageDate.getTime();
  const differenceDays = Math.floor(difference / (1000 * 3600 * 24));

  let dateForShow = '';

  if (todayDate === messageDate.getDate() && todayMonth === messageDate.getMonth() + 1 && todayYear === messageDate.getFullYear()) {
    dateForShow = `${messageDate.getHours()}:${('0' + messageDate.getMinutes()).slice(-2)}`;
  } else if (differenceDays < 7) {
    dateForShow = new Intl.DateTimeFormat('ru-RU', {weekday: 'short'}).format(messageDate);
  } else {
    dateForShow = `${messageDateParts[2]}.${messageDateParts[1]}.${messageDateParts[0]}`;
  }
  return dateForShow;
}

export const getMonthNameInGenetiveCase = (monthIndex: string) => {
	const monthNames = 
		['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 
			'августа', 'сентября', 'октября', 'ноября', 'декабря'];
	return monthNames[parseInt(monthIndex) - 1] || '';
};


export const convertEventDate = (dateTimeOfEvent: string) => {
  if (!dateTimeOfEvent) return;
//TODO: переписать через использование класса Date по аналогии с предыдущими методами
  const [datePart, timePart] = dateTimeOfEvent.split('T');
  const [year, month, day] = datePart.split('-');
  const monthName = getMonthNameInGenetiveCase(month);
  
  const time = timePart.startsWith("0") ? timePart.substring(1, 5) : timePart.substring(0, 5);

  const eventDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  const currentDate = new Date();

  const status = eventDate > currentDate ? '' : 'Завершено'

  return {day, month: monthName, year, time, status};
};